const fileNameArr = [];
const requireAll = requireContext =>
    requireContext.keys().map(item => {
        fileNameArr.push(item);
        return requireContext(item);
    });
const req = require.context('./svg', true, /\.svg$/);
const iconMap = requireAll(req);

export default fileNameArr
    .map(item => {
        return item.substring(item.lastIndexOf('/') + 1, item.length).replace('.svg', '');
    })
    .sort((a, b) => a.localeCompare(b));
